import {FlexiButton} from "@flexinet/ui-components";
import {TiArrowForward} from "react-icons/ti";

interface ForwardButtonProps {
    onClick: () => void;
}

export const ForwardButton = ({onClick}: ForwardButtonProps) => {
    return (
        <FlexiButton variant={'outline'} leftSection={<TiArrowForward/>} onClick={onClick}>
            Forward
        </FlexiButton>
    );
};
